/* eslint-disable */
export default {
  _title: 'title',
}